import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationService } from './pagination.service';
import { GenerateService } from './generate.service';
import { EnvironmentService } from './environment.service';
import { UirouterMigrationService } from './uirouter.migration.service';
import { ComponentHelperService } from './component-helper.service';

@NgModule({
  imports: [CommonModule],
  providers: [PaginationService, GenerateService, EnvironmentService, UirouterMigrationService, ComponentHelperService],
})
export class UtilModule {}



// WEBPACK FOOTER //
// ./src/app/common/services/util/util.module.ts